import { FormProvider } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { ModalWrapper } from '@microservices/wiskey-react-components'

import { ModalFormContainer } from '@components/ModalFormContainer'

import { GETCommand } from '@types'
import { Variable, FieldInfo } from '@microservices/wiskey-react-components'

import { CommandPickerController, CommandPickerControllerProps } from '../CommandPickerController'

import { useAddCommandsDialog } from './hooks/useAddCommandsDialog'

export type AddCommandsDialogType = {
  objectCode: string
  onCloseDialog: () => void
  onChangeCommands: (value?: GETCommand[] | null) => void
  commands?: GETCommand[] | null
  commandPickerControllerProps?: Partial<CommandPickerControllerProps>
  scriptVariables?: Variable[]
  scriptFieldsInfo?: FieldInfo[]
}

export const AddCommandsDialog = (props: AddCommandsDialogType) => {
  const {
    objectCode,
    onCloseDialog,
    onChangeCommands,
    commands,
    commandPickerControllerProps = {},
    scriptVariables,
    scriptFieldsInfo,
  } = props

  const { t } = useTranslation()

  const {
    state: { methods },
    handlers: { handleSave },
  } = useAddCommandsDialog({
    commands,
    onChangeCommands,
    onCloseDialog,
  })

  const {
    formState: { isDirty },
  } = methods

  return (
    <FormProvider {...methods}>
      <ModalWrapper
        isShow
        disabledSave={!isDirty}
        title={`${t('addDialog.edit')} Commands`}
        width={1000}
        containerStyle={{
          px: 0.5,
          py: 0.5,
        }}
        onClose={onCloseDialog}
        onSave={handleSave}
      >
        <ModalFormContainer maxHeight={600}>
          <CommandPickerController
            {...commandPickerControllerProps}
            isAnotherObjectWithRequestData
            commandName='name'
            containerSx={{ mt: 1 }}
            isSelectedCommandOptionDisabled={false}
            name='commands'
            objectCode={objectCode}
            scriptVariables={scriptVariables}
            scriptFieldsInfo={scriptFieldsInfo}
          />
        </ModalFormContainer>
      </ModalWrapper>
    </FormProvider>
  )
}
